import { render, staticRenderFns } from "./loginform-component.vue?vue&type=template&id=56e6c1f2"
import script from "./loginform-component.vue?vue&type=script&lang=ts"
export * from "./loginform-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports